import { render, staticRenderFns } from "./DocumentPickerV1Properties.vue?vue&type=template&id=0903b24a&"
import script from "./DocumentPickerV1Properties.vue?vue&type=script&lang=js&"
export * from "./DocumentPickerV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports